import {
  getBundleProductDetails,
  getProductOfferFlags,
} from '@monofront/business/utils';
import { useProduct } from '../ProductCard';
import { useTranslations } from 'next-intl';
import { useProductPricing } from '@monofront/business/hooks/product/useProductPricing';
import { useProductCustomer } from '@monofront/business/contexts';
import { FC } from 'react';

type ProductPromotionalOfferProps = {
  quantity?: number;
};

export const ProductPromotionalOffer: FC<ProductPromotionalOfferProps> = ({
  quantity = 1,
}) => {
  const product = useProduct();
  const { isMalin } = useProductCustomer();
  const tCatalog = useTranslations('Catalog');

  if (!product) {
    return null;
  }

  const productPricing = useProductPricing(product, quantity);

  if (productPricing.breakdown.malinDiscountPercent && isMalin) {
    return (
      <p id="promotionalOffer" className="tw-grid-area-[promotionalOffer]">
        <span className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-alert">
          {tCatalog('tagMalin')}
        </span>
      </p>
    );
  }

  const { productBundleNumber, productBundleSale } = getBundleProductDetails(
    product.tags,
  );

  const { isKit, isBundle } = getProductOfferFlags(product);

  if (!isBundle && !isKit) {
    return null;
  }

  return (
    <p id="promotionalOffer" className="tw-grid-area-[promotionalOffer]">
      <span className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-alert">
        -{productBundleSale}%{' '}
        {isKit
          ? tCatalog('versusUnitPrice')
          : tCatalog('fromNbProducts', {
              number: productBundleNumber,
            })}{' '}
      </span>
    </p>
  );
};
